module.exports = __webpack_public_path__ + "img/material-card1.b72ad5f0.png";